(() => {
  const germany = {
    before: [
      ['🔑', 'Buscar Alquiler', '/mejor-plataforma-para-buscar-piso-en-alemania/'],
      ['🏥', 'Seguro Médico', '/mejor-seguro-de-salud-para-expats-en-alemania/'],
      ['✈️', 'Viajar Seguro', '/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/'],
      ['📄', 'Armar tu CV', '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/'],
      ['📝', 'Traducciones', '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'],
      ['🎓', 'Validar Títulos', '/como-homologar-tu-titulo-universitario-en-europa/']
    ],
    week: [
      ['🏦', 'Abrir Cuenta', '/mejor-cuenta-bancaria-para-extranjeros-en-alemania/'],
      ['📱', 'Tu Celular', '/mejor-operador-de-movil-para-expats-en-alemania/']
    ],
    settled: [
      ['📦', 'Enviar Cajas', '/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/'],
      ['💸', 'Remesas a Casa', '/mejor-app-para-enviar-dinero-a-latam-desde-europa/'],
      ['📊', 'Taxes e Impuestos', '/mejor-app-para-hacer-la-declaracion-de-impuestos-en-alemania/'],
      ['🗣️', 'Aprender Idioma', '/mejor-curso-de-aleman-online-con-certificado/'],
      ['📺', 'TV de tu País', '/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/'],
      ['💳', 'Tarjetas Globales', '/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/']
    ]
  };

  const spain = {
    before: [
      ['🔑', 'Buscar Alquiler', '/mejor-plataforma-para-buscar-piso-en-espana/'],
      ['🏥', 'Seguro Médico', '/mejor-seguro-de-salud-para-recien-llegados-a-espana/'],
      ['✈️', 'Viajar Seguro', '/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/'],
      ['📄', 'Armar tu CV', '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/'],
      ['📝', 'Traducciones', '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'],
      ['🎓', 'Validar Títulos', '/como-homologar-tu-titulo-universitario-en-europa/']
    ],
    week: [
      ['🏦', 'Abrir Cuenta', '/mejor-cuenta-bancaria-para-extranjeros-en-espana/'],
      ['📱', 'Tu Celular', '/mejor-operador-de-movil-para-expats-en-espana/']
    ],
    settled: [
      ['📦', 'Enviar Cajas', '/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/'],
      ['💸', 'Remesas a Casa', '/mejor-app-para-enviar-dinero-a-latam-desde-europa/'],
      ['📊', 'Taxes e Impuestos', '/mejor-app-para-hacer-la-declaracion-de-la-renta-en-espana/'],
      ['🗣️', 'Aprender Idioma', '/mejor-curso-de-ingles-y-frances-online-con-profesores-nativos/'],
      ['📺', 'TV de tu País', '/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/'],
      ['💳', 'Tarjetas Globales', '/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/']
    ]
  };

  const phaseKey = { antes: 'before', semana: 'week', vida: 'settled' };
  const collections = { alemania: germany, espana: spain };
  let country = 'alemania';
  let openPhase = null;
  const phaseItems = [...document.querySelectorAll('.pe-phase-item')];
  if (!phaseItems.length) return;

  const cardsMarkup = (cards) => `<div class="pe-accordion-grid">${cards.map(([icon, title, href]) => `<a href="${href}#primo-comparador" class="pe-accordion-card"><i>${icon}</i><strong>${title}</strong></a>`).join('')}</div>`;

  const renderOpenPanel = () => {
    if (!openPhase) return;
    const item = phaseItems.find((phase) => phase.dataset.phase === openPhase);
    const cards = collections[country][phaseKey[openPhase]];
    item.querySelector('.pe-phase-panel-content').innerHTML = cardsMarkup(cards);
  };

  const closeAllPhases = () => {
    openPhase = null;
    phaseItems.forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('.pe-phase-trigger').setAttribute('aria-expanded', 'false');
      item.querySelector('.pe-phase-panel-content').innerHTML = '';
    });
  };

  const isMobileRoute = () => window.matchMedia('(max-width: 767px)').matches;

  const routeHeaderOffset = () => {
    const header = document.querySelector('.pe-home-header-rebuild');
    return (header?.getBoundingClientRect().height || 0) + 16;
  };

  const scrollCountryAndStagesIntoView = () => {
    if (!isMobileRoute()) return;
    closeAllPhases();
    const countryGrid = document.querySelector('.pe-country-grid-workflow');
    if (!countryGrid) return;
    window.requestAnimationFrame(() => {
      const targetTop = window.scrollY + countryGrid.getBoundingClientRect().top - routeHeaderOffset();
      window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
    });
  };

  const setPhase = (nextPhase) => {
    const sameOpenPhase = openPhase === nextPhase;
    closeAllPhases();
    if (sameOpenPhase) return;
    openPhase = nextPhase;
    const activeItem = phaseItems.find((item) => item.dataset.phase === openPhase);
    activeItem.classList.add('is-open');
    activeItem.querySelector('.pe-phase-trigger').setAttribute('aria-expanded', 'true');
    renderOpenPanel();
  };

  document.querySelectorAll('.pe-country-card').forEach((button) => {
    button.addEventListener('click', () => {
      country = button.dataset.country;
      document.querySelectorAll('.pe-country-card').forEach((card) => {
        const active = card === button;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-selected', String(active));
      });
      renderOpenPanel();
      scrollCountryAndStagesIntoView();
    });
  });

  phaseItems.forEach((item) => {
    item.querySelector('.pe-phase-trigger').addEventListener('click', () => setPhase(item.dataset.phase));
  });
  const spanishGuidePaths = [
    '/la-seguridad-social-en-espana-como-darte-de-alta-para-trabajar-legalmente/',
    '/el-empadronamiento-en-espana-como-conseguirlo-sin-contrato-a-tu-nombre/',
    '/el-nie-y-el-tie-en-espana-la-guia-para-no-perder-meses-en-el-tramite/'
  ];

  const applySpanishGuideFlags = () => {
    document.querySelectorAll('.pe-guide-card').forEach((card) => {
      const path = new URL(card.href, window.location.origin).pathname;
      const title = (card.querySelector('h3')?.textContent || '').toLocaleLowerCase('es-ES');
      if (!spanishGuidePaths.includes(path) && !title.includes('en españa')) return;
      const flag = card.querySelector('.pe-guide-flag');
      if (flag) {
        flag.classList.remove('pe-guide-flag-de');
        flag.classList.add('pe-guide-flag-es');
        flag.setAttribute('aria-label', 'España');
      }
    });
  };

  applySpanishGuideFlags();
  window.addEventListener('load', applySpanishGuideFlags, {once: true});
  window.setTimeout(applySpanishGuideFlags, 1200);

  const resourceSignup = document.querySelector('[data-resource-signup]');
  if (resourceSignup) {
    const countryButtons = [...resourceSignup.querySelectorAll('[data-resource-country]')];
    const countryLabel = resourceSignup.querySelector('[data-resource-country-label]');
    const emailRow = resourceSignup.querySelector('.pe-resource-email-row');
    const emailInput = resourceSignup.querySelector('[data-members-email]');
    const submitButton = resourceSignup.querySelector('button[type="submit"]');

    countryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const destination = button.dataset.resourceCountry;
        countryButtons.forEach((countryButton) => {
          const selected = countryButton === button;
          countryButton.classList.toggle('is-selected', selected);
          countryButton.setAttribute('aria-pressed', String(selected));
        });
        countryLabel.value = `Destino: ${destination}`;
        resourceSignup.classList.add('is-country-selected');
        emailRow.hidden = false;
        emailInput.disabled = false;
        submitButton.disabled = false;
        window.setTimeout(() => emailInput.focus(), 0);
      });
    });
  }

  const scrollRoutesToHeading = (behavior = 'auto') => {
    if (!isMobileRoute()) return;
    const routes = document.getElementById('rutas');
    const heading = routes?.querySelector('.pe-workflow-heading');
    if (!routes || !heading) return;
    const targetTop = window.scrollY + heading.getBoundingClientRect().top - routeHeaderOffset();
    window.scrollTo({ top: Math.max(0, targetTop), behavior });
  };

  const alignRoutesClosed = () => {
    if (window.location.hash !== '#rutas') return;
    closeAllPhases();
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => scrollRoutesToHeading('auto'));
    });
  };

  document.querySelectorAll('a[href="#rutas"], a[href="/#rutas"]').forEach((link) => {
    link.addEventListener('click', () => {
      closeAllPhases();
      window.setTimeout(() => scrollRoutesToHeading('smooth'), 0);
    });
  });

  const alignGuidesAtTop = () => {
    if (window.location.hash !== '#guias') return;
    const guides = document.getElementById('guias');
    const grid = guides?.querySelector('.pe-guides-grid');
    if (!guides || !grid) return;
    const gridBottom = window.scrollY + grid.getBoundingClientRect().bottom;
    const targetTop = Math.max(
      guides.offsetTop,
      gridBottom - window.innerHeight + 22
    );
    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
  };

  const queueGuidesAlignment = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(alignGuidesAtTop);
    });
  };

  document.querySelectorAll('a[href="#guias"]').forEach((link) => {
    link.addEventListener('click', () => {
      window.setTimeout(queueGuidesAlignment, 0);
    });
  });
  window.addEventListener('hashchange', () => {
    alignRoutesClosed();
    queueGuidesAlignment();
  });
  window.addEventListener('load', () => {
    window.setTimeout(alignRoutesClosed, 80);
    window.setTimeout(queueGuidesAlignment, 80);
  }, { once: true });

  // Estado inicial: ninguna fase se despliega hasta que el visitante elige una.
  closeAllPhases();
  window.setTimeout(alignRoutesClosed, 180);
  window.setTimeout(queueGuidesAlignment, 180);
})();
